module.exports = __webpack_public_path__ + "assets/img/queuing.1a13b2e0.svg";